module.exports = __webpack_public_path__ + "img/tech_service_menue_1.03801f9b.png";